import React, { type ReactNode } from "react";
import ReactDOM from "react-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import styles from "./Tooltip.module.scss";
import { Link } from "react-router-dom";

const domNode = document.createElement("div");
domNode.className = styles.tooltipDiv ?? "";
document.body.appendChild(domNode);

// Wrapper component to portal react-tooltips
const BodyPortal: React.FC<{ children: ReactNode }> = ({ children }) => {
  return ReactDOM.createPortal(children, domNode);
};

interface TooltipProps {
  id: string | number;
  data: string;
  maxLength?: number;
  maxWidth?: number | string;
  children?: ReactNode;
}
const Tooltip: React.FC<TooltipProps> = ({
  maxLength,
  data,
  children,
  id,
  maxWidth,
}) => {
  if (maxLength && data.length <= maxLength) {
    return <>{children || data}</>;
  } else {
    return (
      <>
        <BodyPortal>
          <ReactTooltip
            id={id.toString()}
            classNameArrow="arrow"
            // arrowColor="red"
            // className={styles.tooltip}
            style={{
              position: "fixed",
              zIndex: 9,
              maxWidth: maxWidth || "250px",
            }}
            delayHide={100}
            // float={true}
            clickable={true}
          />
        </BodyPortal>
        <Link
          to="#"
          className={styles.anchorTag}
          data-tooltip-id={String(id)}
          data-tooltip-html={`<div class=${styles.tooltip}><p>${data}</p></div>`}
        >
          {children ||
            (maxLength ? data.slice(0, maxLength - 2) + "..." : data)}
        </Link>
      </>
    );
  }
};
export default Tooltip;
